import type { TweetListResponsePage } from './tweetListResponsePage';

export interface TweetListResponse {
  code?: string;
  message?: string;
  page?: TweetListResponsePage;
  success?: boolean;
}
